import http from "./httpService";
import configdata from "./config.json";

let apiEndpoint = "";
if (process.env.NODE_ENV !== "production") {
  apiEndpoint = `${configdata.apiUrl}/publicblog`;
} else {
  apiEndpoint = `${configdata.herokuUrl}/publicblog`;
}

export async function getPublicBlogComment(BlogId) {
  const data = await http.post(`${apiEndpoint}/getPublicCommentForBlog`, {
    BlogId,
  });
  return data;
}

export async function postPublicBlogComment(comment) {
  const data = await http.post(`${apiEndpoint}/postPublicBlogComment`, comment);
  return data;
}
export async function getAllPublicBlogComment(comment) {
  const data = await http.get(`${apiEndpoint}/getAllPublicComments`);
  return data;
}
export async function deletePublicBlogComment(commentID) {
  const data = await http.post(`${apiEndpoint}/deletePublicCommentForBlog`, {
    commentID,
  });
  return data;
}

export default {
  getPublicBlogComment,
  postPublicBlogComment,
  getAllPublicBlogComment,
  deletePublicBlogComment,
};
